<template>
  <div class="card my-3">
    <div class="card-header">
      <span>比較する業界の選択</span>
    </div>
    <div class="card-body">
      <form action="#">
        <div class="form-check" v-bind:key="industry.idx" v-for="industry in industries">
          <label class="form-check-label">
          <input type="radio" v-model="selected" :value="industry.idx" class="form-check-input" v-on:change="onIndustryChange">
          {{ industry.name }}
          </label>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
// import _ from 'lodash'

export default {
  name: 'IndustrySelector',
  data () {
    return {
      selected: 0,
      industries: [
        {idx: 0, name: '指定なし'},
        {idx: 1, name: 'メーカー'},
        {idx: 2, name: '商社'},
        {idx: 3, name: '百貨店・ストア・専門店'},
        {idx: 4, name: '金融・証券・保険'},
        {idx: 5, name: '情報(通信・マスコミ)'},
        {idx: 6, name: 'ソフトウェア・情報処理'},
        {idx: 7, name: 'サービス'}
      ]
    }
  },
  props: [],
  computed: {
  },
  methods: {
    onIndustryChange (event) {
      this.$store.dispatch('graphDatasets/setIndustry', this.selected)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/IndustrySelector.vue